module.exports = __webpack_public_path__ + "static/media/roulette.79098ef8.png";